module.exports = __webpack_public_path__ + "img/Calendar_Xsmall_Button-active.aa7f16dd.svg";